import { render, staticRenderFns } from "./DeveloperPortal.vue?vue&type=template&id=6fe0d37e"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports